/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserAlertNotificationSetting } from '../../models/user-alert-notification-setting';

export interface DeleteSetting_3$Params {
  settingId: number;
}

export function deleteSetting_3(http: HttpClient, rootUrl: string, params: DeleteSetting_3$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAlertNotificationSetting>> {
  const rb = new RequestBuilder(rootUrl, deleteSetting_3.PATH, 'delete');
  if (params) {
    rb.path('settingId', params.settingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserAlertNotificationSetting>;
    })
  );
}

deleteSetting_3.PATH = '/api/user/notification/alert/setting/{settingId}';
